import { ComputedRef } from 'vue'

import { Bookmark } from '@/domain/value_objects/bookmark/bookmark'
import { BookmarkViewModel } from '@/presentation/viewmodels/bookmark/bookmarkViewModel'

export class BookmarkPresenter {
  private viewModel: BookmarkViewModel

  constructor(viewModel: BookmarkViewModel) {
    this.viewModel = viewModel
  }

  get bookmark(): ComputedRef<Bookmark> {
    return this.viewModel.bookmark
  }

  get isLoading(): ComputedRef<boolean> {
    return this.viewModel.isLoading
  }

  get error(): ComputedRef<string | null> {
    return this.viewModel.error
  }

  async getBookmark(userId: string): Promise<void> {
    return this.viewModel.getBookmark(userId)
  }

  async postBookmark(problemId: string, userId: string): Promise<void> {
    return this.viewModel.postBookmark(problemId, userId)
  }

  async deleteBookmark(problemId: string, userId: string): Promise<void> {
    return this.viewModel.deleteBookmark(problemId, userId)
  }
}
